import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';
import BookDetail from './book.gts';
import MusicDetail from './music.gts';
import PersonDetail from './person.gts';
import PlaceDetail from './place.gts';
import PodcastDetail from './podcast.gts';
import ProductDetail from './product.gts';
import TVShowDetail from './tvshow.gts';
import VideoGameDetail from './video-game.gts';
import MovieDetail from './movie.gts';
import type { Item } from '../../schemas/item.ts';

interface Signature {
  Args: {
    item: Item;
    distance?: string | null;
    watchRegion?: string;
    subscribedServices?: number[];
  };
}

/**
 * Type-specific enrichment details (ratings, links, metadata).
 * Rendered without a card wrapper — the parent page owns the layout.
 */
const ItemDetail: TOC<Signature> = <template>
  {{#if @item.enrichedData}}
    {{#if (eq @item.type "movie")}}
      <MovieDetail
        @data={{@item.enrichedData}}
        @watchRegion={{@watchRegion}}
        @subscribedServices={{@subscribedServices}}
      />
    {{else if (eq @item.type "tv_show")}}
      <TVShowDetail
        @data={{@item.enrichedData}}
        @watchRegion={{@watchRegion}}
        @subscribedServices={{@subscribedServices}}
      />
    {{else if (eq @item.type "music")}}
      <MusicDetail @data={{@item.enrichedData}} />
    {{else if (eq @item.type "book")}}
      <BookDetail @data={{@item.enrichedData}} @name={{@item.name}} />
    {{else if (eq @item.type "video_game")}}
      <VideoGameDetail @data={{@item.enrichedData}} />
    {{else if (eq @item.type "place")}}
      <PlaceDetail @data={{@item.enrichedData}} @distance={{@distance}} />
    {{else if (eq @item.type "person")}}
      <PersonDetail @data={{@item.enrichedData}} />
    {{else if (eq @item.type "podcast")}}
      <PodcastDetail @data={{@item.enrichedData}} />
    {{else if (eq @item.type "product")}}
      <ProductDetail @data={{@item.enrichedData}} />
    {{/if}}
  {{else}}
    <div class="flex flex-col gap-4">
      <p class="text-base-content/70">No additional details available for this
        item.</p>
      <div>
        <a
          href="https://www.google.com/search?q={{encodeURIComponentHelper
            @item.name
          }}"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-outline btn-sm"
        >
          Search on Google ↗
        </a>
      </div>
    </div>
  {{/if}}
</template>;

function encodeURIComponentHelper(str: unknown): string {
  return encodeURIComponent(typeof str === 'string' ? str : '');
}

export default ItemDetail;
